import { useCallback, useMemo } from 'react'
import { stringify } from 'query-string'
import { useSelector } from 'react-redux'
import { companySelector } from 'app-redux/selectors'
import { getToken } from 'utils/cookies'
import { ensureFreshToken } from 'utils/axios'

// Hook untuk handle url handoff ke aplikasi crm
const useUrlCrm = () => {
  const { selectedEndpoint, website_id: websiteId } = useSelector(companySelector)

  const buildUrlCrm = useCallback(
    (token) => {
      const searchs = {
        token,
        website_id: websiteId,
        endpoint: selectedEndpoint,
      }
      const url = import.meta.env.VITE_CRM_URL || 'https://app.crm.id'
      return `${url}/p/app-connect?${stringify(searchs)}`
    },
    [selectedEndpoint, websiteId],
  )

  // Dipakai sebagai href (fallback middle-click / buka di tab baru)
  const urlCrm = useMemo(() => buildUrlCrm(getToken()), [buildUrlCrm])

  // Dipakai saat klik: pastikan token terbaru (refresh dulu jika hampir/sudah expired)
  // supaya crm tidak menerima token kadaluarsa dan meminta login ulang
  const getFreshUrlCrm = useCallback(async () => {
    const token = await ensureFreshToken()
    if (!token) {
      return null
    }
    return buildUrlCrm(token)
  }, [buildUrlCrm])

  return { urlCrm, getFreshUrlCrm }
}

export default useUrlCrm
